export default "__VITE_ASSET__DJJslXbc__"